import React from 'react'
import styled from "styled-components";

const Line = styled.div`
    position: absolute;
    width: 100%;
    height: 2px;
    top: 0;
    right: 0;

    @media (min-width: 1920px){
        right: 0;
    }

    @media (max-width: 1620px){
        display: none;
    }
`;

const Body = styled.div`
    width: 50%;
    height: 2px;
    border-bottom: 2px dashed #38393B;
    position: absolute;
    top: 0;
    margin-top: 50px;
    right: 0;

    &:before{
        content: '';
        width: 100%;
        height: 2px;
        max-width: calc(1920px / 7);
        border-bottom: 2px dashed #38393B;
        position: absolute;
        top: 97px;
        left: -237px;
        transform: rotate(-45deg);
    }
`;


const TopLine = () => {
    return (
        <Line>
            <Body />
        </Line>
    )
}

export default TopLine
